







































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { User } from '@/models/user.interface';
import NoResult from '@/components/common/NoResult.vue';
import { ModalOptions } from '@/models/modal.interface';
import { PaginationInfo } from '@/models/util.interface';

@Component({ components: { NoResult } })
export default class UserTable extends Vue {
  @Action('openModalAction') public openModalAction!: (payload: ModalOptions) => void;
  @Action('selectUserAction') public selectUserAction!: (payload: User) => void;
  @Action('removeUserAction') public removeUserAction!: (id: string) => Promise<void>;
  @Action('changeUserPageAction') public changeUserPageAction!: (id: number) => void;
  @Getter public isModalValidated!: boolean;
  @Getter public modalPayload!: string;
  @Getter public userPaginationInfo!: PaginationInfo;
  @Getter public usersLoading!: boolean;
  @Getter public userConnected!: User;
  @Prop() private users!: User[];

  private page: number;

  constructor() {
    super();
    this.page = 1;
  }

  public showModal(user: User): void {
    this.openModalAction({
      title: 'Confirmation',
      message: `Êtes vous sûr de vouloir supprimer cet utilisateur ?`,
      payload: user._id,
    });
  }

  public goToEdit(user: User): void {
    this.selectUserAction(user);
    this.$router.push(`/user/${user._id}/edit`);
  }

  public onPaginate(page: number) {
    this.changeUserPageAction(page);
  }

  @Watch('isModalValidated')
  private onModalValidatedChanged(value: boolean, oldValue: boolean) {
    value && this.removeUser();
  }

  @Watch('userPaginationInfo')
  private onPaginationChanged(value: PaginationInfo, oldValue: PaginationInfo) {
    this.page = value.page ? +value.page : 1;
  }

  @Emit()
  private async removeUser(): Promise<string> {
    await this.removeUserAction(this.modalPayload);
    return this.modalPayload;
  }
}
